export default __webpack_public_path__ + "static/media/ic_browse_active.0b18fddb.svg";